import type { ReactNode } from "react";
import type { GestureResponderEvent, StyleProp, ViewStyle } from "react-native";
import { View } from "../View";
import { NavSidePanelItemNode } from "./ItemNode";
import type {
  NavSidePanelDisclosureIconRenderProps,
  NavSidePanelItem,
  NavSidePanelItemContentRenderProps,
  NavSidePanelItemRenderProps,
} from "./NavSidePanel.types";

interface NavSidePanelSectionProps {
  readonly items: readonly NavSidePanelItem[];
  readonly depthIndent: number;
  readonly expandedItemIds: readonly string[];
  readonly minimized: boolean;
  readonly onToggleExpanded: (itemId: string) => void;
  readonly onItemPress?: (item: NavSidePanelItem, event: GestureResponderEvent) => void;
  readonly renderItem?: (props: NavSidePanelItemRenderProps) => ReactNode;
  readonly renderItemContent?: (props: NavSidePanelItemContentRenderProps) => ReactNode;
  readonly renderDisclosureIcon?: (props: NavSidePanelDisclosureIconRenderProps) => ReactNode;
  readonly style?: StyleProp<ViewStyle>;
}

export function NavSidePanelSection({
  items,
  depthIndent,
  expandedItemIds,
  minimized,
  onToggleExpanded,
  onItemPress,
  renderItem,
  renderItemContent,
  renderDisclosureIcon,
  style,
}: NavSidePanelSectionProps) {
  return (
    <View gap="xs" style={style}>
      {items.map((item) => (
        <NavSidePanelItemNode
          key={item.id}
          item={item}
          depth={0}
          depthIndent={depthIndent}
          expandedItemIds={expandedItemIds}
          minimized={minimized}
          onToggleExpanded={onToggleExpanded}
          {...(onItemPress ? { onItemPress } : {})}
          {...(renderItem ? { renderItem } : {})}
          {...(renderItemContent ? { renderItemContent } : {})}
          {...(renderDisclosureIcon ? { renderDisclosureIcon } : {})}
        />
      ))}
    </View>
  );
}
